import Icon from '@material-ui/icons/Grade';

export default {
  Icon,
  dialogs: {
  },
  routes: {
  },
  components: {
  },
  resources: {
  },
};
